'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Radio = undefined;

var _components = require('@rebass/components');

var _components2 = _interopRequireDefault(_components);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Radio = exports.Radio = (0, _components2.default)({
  is: 'input',
  type: 'radio',
  m: 0,
  mr: 2
}, 'space', 'color');

Radio.displayName = 'Radio';

exports.default = Radio;


//////////////////
// WEBPACK FOOTER
// ./~/rebass/dist/Radio.js
// module id = 146
// module chunks = 22676092666560 46504955462500 107818501498521 221374088121123